import { useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatus } from '@fukuri-admins/apis/client/gen/endpoints';

export const useGetStressAssessmentBranchLinkageStatus =
  useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchLinkageStatus;
